import {TextField} from '@mui/material';
import {COLORS} from '@fupa/fupa-uikit';
import {styled} from '@mui/material/styles';

export const CustomTextField = styled(TextField)({
  '& .MuiInputBase-input': {
    paddingLeft: '8px',
    paddingRight: '8px',
  },
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: COLORS.fupaSecondary,
    },
    '&.Mui-focused fieldset': {
      borderColor: COLORS.fupaSecondary,
    },
  },
});

interface CustomNumberTextFieldProps {
  maxWidth?: number;
  textAlign?: 'start' | 'end' | 'left' | 'right' | 'center' | 'justify' | 'match-parent' | 'justify-all';
}

export const CustomNumberTextField = styled(CustomTextField, {
  shouldForwardProp: prop => prop !== 'maxWidth' && prop !== 'textAlign' && prop !== 'sx',
})<CustomNumberTextFieldProps>(({maxWidth, textAlign}) => ({
  '& .MuiInputBase-input': {
    textAlign: textAlign ?? 'initial',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '&[type=number]': {
      MozAppearance: 'textfield',
    },
  },
  '& .MuiOutlinedInput-root': {
    maxWidth: maxWidth ?? 'initial',
  },
}));
